import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckIcon, LockIcon, SmartphoneIcon, ClockIcon, RefreshCwIcon } from 'lucide-react';
import { CTAButton } from './ui/CTAButton';
export function PricingSection() {
  const [selectedPlan, setSelectedPlan] = useState<'base' | 'vip'>('vip');
  return <section className="bg-[#0a0a0a] py-12 px-4" id="pricing" data-id="element-112">
      <div className="max-w-2xl mx-auto" data-id="element-113">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-114">
          <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-115">
            Elegí tu Pack
          </h2>
        </motion.div>

        <div className="flex flex-col gap-4 mb-8" data-id="element-116">
          {/* VIP Plan */}
          <motion.div layout onClick={() => setSelectedPlan('vip')} className={`cursor-pointer rounded-2xl border-2 transition-all duration-300 relative ${selectedPlan === 'vip' ? 'border-yellow-500 bg-[#18181b] shadow-[0_0_30px_rgba(202,138,4,0.15)] p-6' : 'border-zinc-800 bg-[#0a0a0a] hover:border-zinc-600 px-5 py-3'}`} data-id="element-117">
            {selectedPlan === 'vip' && <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-yellow-500 text-black px-4 py-1 rounded-full text-xs font-bold whitespace-nowrap" data-id="element-118">
                ⭐ Más Elegido
              </div>}

            <div className={`flex items-center justify-between ${selectedPlan === 'vip' ? 'mb-4 mt-2' : ''}`} data-id="element-119">
              <div className="flex items-center gap-3" data-id="element-120">
                <h3 className={`font-bold ${selectedPlan === 'vip' ? 'text-xl text-yellow-500' : 'text-base text-zinc-400'}`} data-id="element-121">
                  PACK PRO COMPLETO
                </h3>
                {selectedPlan !== 'vip' && <span className="text-zinc-500 text-sm" data-id="element-122">$29.990 ARS</span>}
              </div>
              <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${selectedPlan === 'vip' ? 'border-yellow-500' : 'border-zinc-600'}`} data-id="element-123">
                {selectedPlan === 'vip' && <div className="w-3 h-3 bg-yellow-500 rounded-full" data-id="element-124" />}
              </div>
            </div>

            <AnimatePresence data-id="element-125">
              {selectedPlan === 'vip' && <motion.div initial={{
              opacity: 0,
              height: 0
            }} animate={{
              opacity: 1,
              height: 'auto'
            }} exit={{
              opacity: 0,
              height: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-126">
                  <ul className="space-y-2.5 mb-4" data-id="element-127">
                    {['6 Tomos PDF completos', '6 Bonos Gratis (valorados en $26.950)', 'Acceso inmediato por descarga', 'Tuyo para siempre', 'Apto celular, tablet y computadora'].map((feature, i) => <li key={i} className="flex items-start gap-2" data-id="element-128">
                        <CheckIcon className="w-4 h-4 text-emerald-500 shrink-0 mt-0.5" data-id="element-129" />
                        <span className="text-zinc-300 text-sm" data-id="element-130">{feature}</span>
                      </li>)}
                    <li className="flex items-start gap-2" data-id="element-131">
                      <CheckIcon className="w-4 h-4 text-yellow-500 shrink-0 mt-0.5" data-id="element-132" />
                      <span className="text-white text-sm font-medium" data-id="element-133">
                        Master en Proteínas Vegetales PDF (tofu casero, seitán,
                        tempeh, hamburguesas, chorizos vegetales)
                      </span>
                    </li>
                  </ul>
                  <div className="text-center pt-2 border-t border-zinc-800" data-id="element-134">
                    <span className="text-3xl font-black text-white" data-id="element-135">
                      $29.990
                    </span>
                    <span className="text-zinc-400 ml-1 text-sm" data-id="element-136">ARS</span>
                  </div>
                </motion.div>}
            </AnimatePresence>
          </motion.div>

          {/* Base Plan */}
          <motion.div layout onClick={() => setSelectedPlan('base')} className={`cursor-pointer rounded-2xl border-2 transition-all duration-300 relative ${selectedPlan === 'base' ? 'border-emerald-500 bg-[#18181b] p-6' : 'border-zinc-800 bg-[#0a0a0a] hover:border-zinc-600 px-5 py-3'}`} data-id="element-137">
            <div className={`flex items-center justify-between ${selectedPlan === 'base' ? 'mb-4' : ''}`} data-id="element-138">
              <div className="flex items-center gap-3" data-id="element-139">
                <h3 className={`font-bold ${selectedPlan === 'base' ? 'text-xl text-white' : 'text-base text-zinc-400'}`} data-id="element-140">
                  PACK BASE
                </h3>
                {selectedPlan !== 'base' && <span className="text-zinc-500 text-sm" data-id="element-141">$19.990 ARS</span>}
              </div>
              <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${selectedPlan === 'base' ? 'border-emerald-500' : 'border-zinc-600'}`} data-id="element-142">
                {selectedPlan === 'base' && <div className="w-3 h-3 bg-emerald-500 rounded-full" data-id="element-143" />}
              </div>
            </div>

            <AnimatePresence data-id="element-144">
              {selectedPlan === 'base' && <motion.div initial={{
              opacity: 0,
              height: 0
            }} animate={{
              opacity: 1,
              height: 'auto'
            }} exit={{
              opacity: 0,
              height: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-145">
                  <ul className="space-y-2.5 mb-4" data-id="element-146">
                    {['6 Tomos PDF completos', '6 Bonos Gratis (valorados en $26.950)', 'Acceso inmediato por descarga', 'Tuyo para siempre', 'Apto celular, tablet y computadora'].map((feature, i) => <li key={i} className="flex items-start gap-2" data-id="element-147">
                        <CheckIcon className="w-4 h-4 text-emerald-500 shrink-0 mt-0.5" data-id="element-148" />
                        <span className="text-zinc-300 text-sm" data-id="element-149">{feature}</span>
                      </li>)}
                  </ul>
                  <div className="text-center pt-2 border-t border-zinc-800" data-id="element-150">
                    <span className="text-3xl font-black text-white" data-id="element-151">
                      $19.990
                    </span>
                    <span className="text-zinc-400 ml-1 text-sm" data-id="element-152">ARS</span>
                  </div>
                </motion.div>}
            </AnimatePresence>
          </motion.div>
        </div>

        {/* CTA */}
        <div className="text-center max-w-2xl mx-auto" data-id="element-153">
          <CTAButton className="w-full mb-5" data-id="element-154">
            ✅ COMPRAR AHORA — ACCESO INMEDIATO
          </CTAButton>

          <div className="flex flex-wrap justify-center gap-4 md:gap-6 text-xs text-zinc-400" data-id="element-155">
            <div className="flex items-center gap-1.5" data-id="element-156">
              <LockIcon size={14} data-id="element-157" /> Pago 100% Seguro
            </div>
            <div className="flex items-center gap-1.5" data-id="element-158">
              <ClockIcon size={14} data-id="element-159" /> Acceso Inmediato
            </div>
            <div className="flex items-center gap-1.5" data-id="element-160">
              <SmartphoneIcon size={14} data-id="element-161" /> Apto Celular
            </div>
            <div className="flex items-center gap-1.5" data-id="element-162">
              <RefreshCwIcon size={14} data-id="element-163" /> Garantía 7 Días
            </div>
          </div>
        </div>
      </div>
    </section>;
}